import { takeLatest, put, call } from "redux-saga/effects";
import { handleApiError } from "@utils/errorHandler";

import { loadAllSolutions, loadSingleSolution } from "./SolutionsList.slice";

import {
  loadAllSolutionsAPI,
  loadSingleSolutionAPI,
} from "./SolutionsList.api";

export const LOAD_ALL_SOLUTIONS = {
  LOADING: "Load all solutions loading",
  SUCCESS: "Load all solutions success",
  ERROR: "Load all solutions error",
};

export const LOAD_SINGLE_SOLUTION = {
  LOADING: "Load single solution loading",
  SUCCESS: "Load single solution success",
  ERROR: "Load single solution error",
};

function* loadAllSolutionsWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadAllSolutionsAPI, payload);
    yield put(loadAllSolutions(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_ALL_SOLUTIONS.ERROR, error });
  }
}

function* loadSingleSolutionSagaWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadSingleSolutionAPI, payload);
    yield put(loadSingleSolution(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_SINGLE_SOLUTION.ERROR, error });
  }
}

export function* loadAllSolutionsSaga() {
  yield takeLatest(LOAD_ALL_SOLUTIONS.LOADING, loadAllSolutionsWorker);
}

export function* loadSingleSolutionSaga() {
  yield takeLatest(LOAD_SINGLE_SOLUTION.LOADING, loadSingleSolutionSagaWorker);
}
